export default {
    // We use this invisible char in the beginning of the first editable element
    // to prevent it from becoming empty and erasing style spans
    // http://www.fileformat.info/info/unicode/char/2063/index.htm
    WIX_GUARD: window.location.search.indexOf('funEditorGuardVisible=true') === -1 ? '\u200b' : '⏈',
    CK_GUARD: '\u200b',
    BACKSPACE_KEYCODE: 8,
    RETURN_KEYCODE: 13,
    ENTER_KEYCODE: 14,
    SHIFT_KEYCODE: 16,
    CONTROL_KEYCODE: 17,
    ALT_KEYCODE: 18,
    PAGE_UP_KEYCODE: 33,
    PAGE_DOWN_KEYCODE: 34,
    END_KEYCODE: 35,
    HOME_KEYCODE: 36,
    LEFT_KEYCODE: 37,
    UP_KEYCODE: 38,
    RIGHT_KEYCODE: 39,
    DOWN_KEYCODE: 40,
    DELETE_KEYCODE: 46,
    TEXT_BLOCKS: [
        'p',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'blockquote'
    ],
    COLOR_CLASS_PREFIX: 'color_',
    BACKCOLOR_CLASS_PREFIX: 'backcolor_',
    WINDOWS_APPS_KEY: 'Apps',
    MOUSE_LEFT_CLICK_BUTTON: 1,
    MOUSE_RIGHT_CLICK_BUTTON: 2,
    CURSOR_LOCATIONS: {
        START: 'start',
        END: 'end',
        ALL: 'all',
        NONE: 'none'
    }
};
